import { Component, OnInit } from '@angular/core';
import { faPencilAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Filter } from 'src/app/shared/models/filter.model';
import { Lookup } from 'src/app/shared/models/admin-models/lookup.model';
import { Observable } from 'rxjs';
import { QuestionnarieGroupService } from 'src/app/shared/services/questionnaries-group.service'

@Component({
  selector: 'app-questionnaires-group',
  templateUrl: './questionnaires-group.component.html',
  styleUrls: ['./questionnaires-group.component.sass']
})
export class QuestionnairesGroupComponent implements OnInit {
  faSearch = faSearch;
  faPencilAlt = faPencilAlt;
  faTrashAlt = faTrashAlt;

  addOrEditBool: Boolean = true;
  filter: Filter = new Filter({ Top: 10, Page: 1, Filter: {}, Sort: {} })
  total: number
  lookupId: Number;
  lookupArray: Lookup[] = [];

  filterForm = new FormGroup({
    name: new FormControl('', [])
  })

  lookupForm = new FormGroup({
    name: new FormControl('', [Validators.required])
  })

  constructor(private modalService: NgbModal, private questionnarieGroupService: QuestionnarieGroupService) { }

  ngOnInit() {
    this.getAll()
  }

  getAll() {
    this.filter.data.Filter = {}
    if (this.filterForm.value.name)
      this.filter.data.Filter.Name = this.filterForm.value.name

    this.questionnarieGroupService.gridView(this.filter)
      .subscribe(
        x => {
          this.total = x.total
          this.lookupArray = x.data
        }
      );
  }

  openAddLookupModal(modal) {
    this.lookupForm.reset();
    this.addOrEditBool = true;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
  }
  addLookup() {
    let lookup = new Lookup({ Name: this.lookupForm.value.name })
    this.questionnarieGroupService.createQuestionnarieGroup(lookup)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openEditLookupModal(modal, id) {
    this.addOrEditBool = false;
    this.questionnarieGroupService.getOne(id)
      .then(
        (x: { id: Number, name: String }) => {
          this.lookupId = id;
          this.lookupForm.get('name').setValue(x.name);
          this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
        }
      )
  }
  editLookup() {
    let lookup = new Lookup({ Id: this.lookupId, Name: this.lookupForm.value.name })
    this.questionnarieGroupService.editQuestionnarieGroup(lookup)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openDeleteLookupModal(modal, id) {
    this.lookupId = id;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
  }
  deleteLookup() {
    this.questionnarieGroupService.deleteQuestionnarieGroup([this.lookupId])
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  clearFilters() {
    this.filterForm.reset({ name: '' })
    this.getAll()
  }

}
